<hlm-popover align="end">
  <button
    hlmPopoverTrigger
    hlmBtn
    variant="ghost"
    size="icon-sm"
    type="button"
    [attr.aria-label]="'menu.notifications' | translate"
    data-cy="notifications-button">
    <ng-icon name="lucideBell" />
  </button>
  <hlm-popover-content *hlmPopoverPortal="let ctx" class="w-72" data-cy="notifications-panel">
    <div class="flex flex-col items-center gap-2 py-4 text-center">
      <ng-icon name="lucideBellOff" class="text-muted-foreground text-2xl" aria-hidden="true" />
      <p class="text-sm font-medium">{{ 'menu.noNotifications' | translate }}</p>
      <p class="text-muted-foreground text-xs">{{ 'menu.noNotificationsDescription' | translate }}</p>
    </div>
  </hlm-popover-content>
</hlm-popover>
